module.exports = __webpack_public_path__ + "img/book-bg-2.4281fada.png";